import { atomFamily } from "jotai/utils";
import { useAtom, atom } from "jotai";

// 因为官方的atomWithStorage函数的值必须经过序列化, 不兼容旧数据, 只能自己写了个
const atomWithStorage = (key: string, initialValue?: string) => {
    const newAtom = atom<string>(
        window.localStorage.getItem(key) || initialValue || ""
    );

    return atom(
        get => {
            return get(newAtom);
        },
        (get, set, value: string) => {
            window.localStorage.setItem(key, value);
            set(newAtom, value);
        }
    );
};

const storageAtom = atomFamily(
    ({ key, initialValue }: { key: string; initialValue: string }) =>
        atomWithStorage(key, initialValue),
    (arg1, arg2) => arg1.key === arg2.key
);

export default function useStorage<T>(key: string, initialValue?: string) {
    return useAtom(storageAtom({ key, initialValue: initialValue || "" }));
}
